import React, { useEffect } from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import { OnlinepbxModalMessage } from '@onpbx/onlinepbx-components'
import { featuresModuleService } from '~/store/report-features/features-module-service'
import { AmplitudeCounter } from "~/amplitude-counter";
import ym from 'react-yandex-metrika'
import gtag from "~helpers/gtag";

const Report: React.FC = () => {
  const [modal, setModal] = React.useState<boolean>(false)
  const [value, setValue] = React.useState<string>('')
  const [error, setError] = React.useState<string>('')
  const [postSalesDepartment, result] = featuresModuleService.usePostSalesDepartmentMutation()
  const reg = /[^0-9+()]/g

  const getMetriks = (): object => {
    const gaUid = document.cookie.replace(/(?:(?:^|.*;\s*)_gid\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const ymUid = document.cookie.replace(/(?:(?:^|.*;\s*)_ym_uid\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const roistatVisit = document.cookie.replace(/(?:(?:^|.*;\s*)roistat_visit\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      ga_uid: gaUid,
      ym_uid: ymUid,
      roistat_visit: roistatVisit
    }

  }

  const getUtms = (): any => {
    const utm_medium = document.cookie.replace(/(?:(?:^|.*;\s*)utm_medium\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utm_source = document.cookie.replace(/(?:(?:^|.*;\s*)utm_source\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utm_campaign = document.cookie.replace(/(?:(?:^|.*;\s*)utm_campaign\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utm_term = document.cookie.replace(/(?:(?:^|.*;\s*)utm_term\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utm_content = document.cookie.replace(/(?:(?:^|.*;\s*)utm_content\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      utm_medium,
      utm_source,
      utm_campaign,
      utm_term,
      utm_content
    }
  }

  const getPartnerId = (): any => {
    return document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1') || 0
  }

  const handleClick = () => {
    if (!value) {
      setError('Введите номер телефона.')
      setTimeout(() => setError(''), 3000)
      return
    }
    if (value && value.length < 10) {
      setError('Слишком короткий номер.')
      setTimeout(() => setError(''), 3000)
      return
    }

    const postBody = { ...getUtms(), ...getMetriks() }
    postBody.phone = value
    postBody.partner_id = getPartnerId()

    postSalesDepartment({ moduleType: 'analytics ', body: postBody })
    ym('reachGoal', 'get_consultation', 631388);
    gtag('event', 'click', {'event_category': 'consultation'});
    AmplitudeCounter('click_registration', { 'name_button': 'Оставить заявку', 'page_name': 'Отчёты' })
  }

  useEffect(() => {
    if (result?.isSuccess) {
      setModal(true)
    }
  }, [result])

  const handlePress = (evt: React.KeyboardEvent) => {
    if (evt.key === 'Enter') {
      handleClick()
    }
  }

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (!!error) {
      setError('')
    }
    setValue(evt.target.value.replace(reg, ''))
  }

  return (
    <>
      <Styled.Container>
        <Styled.Title>
          <Styled.GreenText>Управляйте продажами</Styled.GreenText> на основе цифр с сервисом “Бизнес-аналитика”
        </Styled.Title>
        <Styled.CallFormWrapper style={{ marginBottom: '20px' }}>
          <Styled.CallBlock>
            <Styled.CallFormInput
                placeholder='Контактный номер'
                value={value}
                onChange={handleChange}
                onKeyUp={handlePress}
            />
            <Styled.CallFormButton onClick={() => handleClick()}>Оставить заявку</Styled.CallFormButton>
            {error &&
                <Styled.ErrorMassage>
                  {error}
                </Styled.ErrorMassage>}
          </Styled.CallBlock>
        </Styled.CallFormWrapper>
        <Styled.SubText>Влияйте на прибыль и эффективность сотрудников </Styled.SubText>
      </Styled.Container>

      <Styled.BackgroundContainer>
        <Styled.Container>
          <Styled.Title style={{ marginBottom: '16px', color: '#797199'}}>
            Вы сможете <Styled.GreenText>увеличить объем продаж</Styled.GreenText> без дополнительных бюджетов
          </Styled.Title>
          <Styled.SubTitle>
            на рекламу и менеджеров по продажам
          </Styled.SubTitle>
        </Styled.Container>
      </Styled.BackgroundContainer>

      <Styled.Container>
        <Styled.LesserTitle>Сервис поможет понять:</Styled.LesserTitle>
        <Styled.FeatureWrapper>
          <Styled.Feature color='#ECF9FC'>Кто из менеджеров делает больше всего выручки и почему?</Styled.Feature>
        </Styled.FeatureWrapper>
        <Styled.FeatureWrapper>
          <Styled.Feature color='#F3F3FF'>Что нужно изменить в отделе продаж и почему?</Styled.Feature>
          <Styled.Feature color='#E8FAF6'>Как увеличить конверсию и средний чек?</Styled.Feature>
        </Styled.FeatureWrapper>
      </Styled.Container>

      <Styled.Container>
        <Styled.Title>
          Отчеты, которые считают <Styled.GreenText>ключевые метрики</Styled.GreenText> за вас
        </Styled.Title>
        <Styled.QuoteWrapper>
          <Styled.QuoteSubWrapper>
            <Styled.Text style={{ marginBottom: '38px' }}>
              “Управлять можно только тем, что можно измерить”. <br/>Питер Друкер
            </Styled.Text>
            <Styled.Text>
              Теперь оценивать результаты работы и принимать стратегические решения стало легче.
            </Styled.Text>
          </Styled.QuoteSubWrapper>
          <Styled.Image width='428px' height='338px' src={`${process.env.PUBLIC_DIR}/images/features-page/business/report.svg`} />
        </Styled.QuoteWrapper>
        <Styled.Indent/>
        <Styled.Text>Вот что рассказывают наши клиенты:</Styled.Text>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Артем, владелец бизнеса</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Я руковожу колл-центром крупнейшего интернет-магазина в регионе, продаем аксессуары к ноутбукам и телефонам. Поток заказов большой, простоев не бывает. Задача оператора — обзвонить и подтвердить как можно больше заказов.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Каждую неделю у нас собрание руководителей. Я не хочу вручную собирать данные по звонкам и считать показатели, поэтому докупаю модуль «Отчеты». Строю отчет по каждому сотруднику, выгружаю в PDF и показываю на собрании. Все быстро, красиво, с динамикой за период. На фоне коллег, перечисляющих цифры вслух, мой доклад самый наглядный и убедительный. Когда есть визуализация, цифры воспринимаются легче.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
        <Styled.ImageCall src={`${process.env.PUBLIC_DIR}/images/features-page/business/report-call.svg`} />
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Руслан, владелец бизнеса</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>В СРМ я не могу взять настолько детальную информацию, помимо количества звонков. А у нас KPI завязан на среднее время разговора и количество звонков, поэтому пользуемся аналитикой АТС.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>У нас в компании 200 человек и несколько производств, которые привязаны к разным CRM системам. Кто-то сидит на RetaiCRM, кто-то на Amo. Бизнес-аналитика от АТС нам удобнее технически, так как:</Styled.TextComment>
            <Styled.List>
              <Styled.TextList>Все звонки можно посмотреть в одном месте, а не в разных CRM.</Styled.TextList>
              <Styled.TextList>Не надо выдавать права от CRM.</Styled.TextList>
              <Styled.TextList>При изменении номеров сохраняется информация о менеджерах.</Styled.TextList>
            </Styled.List>
          </Quote>
        </Styled.BlockQuote>
      </Styled.Container>

      <Styled.Container style={{ maxWidth: '1260px', borderTop: '1px solid #E0DDEC', paddingBottom: '0' }}>
        <Styled.Title>
          <Styled.GreenText>Продавайте</Styled.GreenText> больше <br/> с Бизнес-аналитикой от onlinepbx
        </Styled.Title>
        <Styled.CallFormWrapper>
          <Styled.CallBlock>
            <Styled.CallFormInput
              placeholder='Контактный номер'
              value={value}
              onChange={handleChange}
              onKeyUp={handlePress}
            />
            <Styled.CallFormButton onClick={() => handleClick()}>Оставить заявку</Styled.CallFormButton>
            {error &&
                <Styled.ErrorMassage>
                  {error}
                </Styled.ErrorMassage>}
          </Styled.CallBlock>
        </Styled.CallFormWrapper>
      </Styled.Container>

      {
        modal &&
          <OnlinepbxModalMessage
            buttons
            isModal
            status='success'
            header='Мы получили Вашу заявку. Менеджер свяжется с Вами в ближайшее время.'
            textButtonLink='Закрыть'
            onClickButtonLink={() => {
              setValue('')
              setModal(false)
            }}
          />
      }
    </>
  )
}

export default Report
